import React, { useEffect } from "react";
import { Box } from "@mui/material";
import AppointmentForm from "../components/Booking/AppointmentForm";
import ContactReinder from "../components/Booking/ContactReminder"

const CorporalStetic = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box component="main">
      <AppointmentForm />
      <ContactReinder />
    </Box>
  );
};

export default CorporalStetic;